<template>
  <section id="section__apply" class="view-container">
    <div class="width-100">
      <v-row class="section-main-row apply__main" no-gutters>
        <v-col cols="12" class="mb-10 mt-10">
          <p class="mb-5 font--m-3">사입 주문 완료!</p>
          <p class="mb-5 font--m-5">
            사입 물건은
            <br />
            내일 오전에 만나보실 수 있어요
          </p>
          <img src="@/assets/images/buybox.png" class="buy-img" alt="buy" />
        </v-col>
      </v-row>

      <v-row class="mb-10 mt-10" no-gutters>
        <v-col :cols="12">
          <BasicButton :to="{ path: '/' }"> 확인 </BasicButton>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import BasicButton from '@/components/common/button/BasicButton.vue'
export default {
  components: { BasicButton },
  data() {
    return {}
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
  },
}
</script>

<style lang="scss" scoped>
#section__apply {
  display: flex;
  text-align: center;
}
</style>
